import React from "react";
import { Container, Stack, Paper, Title, Text, Box } from "@mantine/core";
import { Logo } from "../../generic/Logo";
import { AuthLayoutProps } from "./AuthLayout.types";

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  maxWidth = 480,
  showLogo = true,
}) => {
  return (
    <Box
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Container size="xs" w="100%" style={{ maxWidth }}>
        <Paper
          shadow="xl"
          p="xl"
          radius="lg"
          style={{
            background: "white",
            border: "1px solid #e9ecef",
          }}
        >
          <Stack gap="lg" align="center">
            {showLogo && <Logo size="large" />}

            {title && (
              <Box ta="center" w="100%">
                <Title order={2} size="h3" fw={600} c="gray.8">
                  {title}
                </Title>
                {subtitle && (
                  <Text size="md" c="dimmed" mt="xs">
                    {subtitle}
                  </Text>
                )}
              </Box>
            )}

            <Box w="100%">{children}</Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};
